import { configureStore } from '@reduxjs/toolkit';
import  AppSlice from './AppSlice';
import ResearchDataSlice from './ResearchDataSlice';
import HallOfFameSlice from './HallOfFameSlice';

export const store = configureStore({
  reducer: {
    app: AppSlice,
    researchData: ResearchDataSlice,
    hallOfFame: HallOfFameSlice,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;